import { samplePath } from '../../shared/game/path-curve.js';
import { pointSegmentDistance } from '../../shared/navigation/geometry.js';
import type { MapDefinition, Point } from '../../shared/game/world-types.js';

/** What lies underfoot, for footstep sounds: the drawn roads, followed along the same curve the road surface is drawn on. */
export class Surfaces {
  private readonly roads: { points: Point[]; reach: number }[];

  constructor(map: MapDefinition) {
    this.roads = (map.scenery?.paths ?? []).filter(path => path.kind === 'road').map(path => ({ points: samplePath(path.points, path.points.length * 24), reach: path.width / 2 }));
  }

  onRoad(x: number, z: number) {
    const point = { x, z };
    return this.roads.some(({ points, reach }) => points.some((end, i) => i > 0 && pointSegmentDistance(point, points[i - 1], end) < reach));
  }
}
